document.addEventListener('DOMContentLoaded', () => {
const modoOscuro = localStorage.getItem('modo-oscuro') === 'true';
    
    if (modoOscuro) {
        // Aplica la clase dark-mode inmediatamente sin transición
        document.documentElement.classList.add('dark-mode');
        document.documentElement.classList.remove('no-transition');
    } else {
        // Aplica modo claro y remueve la clase no-transition
        document.documentElement.classList.remove('dark-mode');
        document.documentElement.classList.remove('no-transition');
    }
});
